<template>
    <!-- 操作日志 -->
    <div v-loading="loading" class="business-expense-name">
        <container-title title="操作日志" />
        <div class="main-container-content">
            <el-form label-width="110px" class="search-form">
                <el-row :gutter="24">
                    <el-col :span="8">
                        <el-form-item label="操作人">
                            <user-filter clearable v-model="queryParams.createId" class="search__item"></user-filter>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item label="操作">
                            <el-input v-model.trim="queryParams.type" placeholder="请输入操作内容" clearable></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :span="8">
                        <el-form-item label="操作结果">
                            <el-select v-model="queryParams.isSuccess" placeholder="请选择操作结果" clearable>
                                <el-option label="成功" :value="1" />
                                <el-option label="失败" :value="0" />
                            </el-select>
                        </el-form-item>
                    </el-col>

                    <el-col :span="24" class="search-btn">
                        <!-- 导入业务预算组件（包含按钮和弹窗） -->
                        <el-button class="ml-10" :disabled="loading" type="primary" v-throttle="[refresh,`click`,1000]">查询</el-button>
                        <el-button class="ml-10" :disabled="loading" v-throttle="[resetAll,`click`,1000]">重置</el-button>
                    </el-col>
                </el-row>
            </el-form>
            <div class="mb-12">
            </div>
            <common-table :data="tableData" :tableColumnData="tableColumns" :loading="loading"
                :max-height="tableHeight">
            </common-table>
            <pager @currentchange="changePage" @sizechange="changeSize" v-model.trim="pageDto">
            </pager>
        </div>
    </div>
</template>
<script>
import UserFilter from "library/components/UserFilter";

import { defineComponent, ref, reactive, onMounted, getCurrentInstance } from 'vue'
import { awaitWrapper, sleep } from "@/common/utils/assist.js";

import { PERSON_IN_CHARGE_LIST } from './config.js'
import { usePageDto } from '@/common/mixins/usePageDto'
import { useSetTableHeight } from '@/common/mixins/useSetTableHeight'

import {
    queryOptLog, // 
} from './request.js'

export default defineComponent({
    components: {
        UserFilter,
    },

    setup(props, context) {
        const { proxy } = getCurrentInstance()

        const loading = ref(false)
        const queryParams = reactive({
            createId: '', // 操作人
            type: '', // 操作
            isSuccess: '', // 操作结果
        })
        const tableData = ref([])
        // 查询条件下拉框
        const tableColumns = ref(PERSON_IN_CHARGE_LIST)

        const fetchList = async () => {
            const params = {
                pageDto: {
                    pageNum: pageDto.pageNum,
                    pageSize: pageDto.pageSize,
                },
                createId: queryParams.createId || null, // 操作人
                type: (queryParams.type||'').trim(), // 操作（字符串）
                isSuccess: queryParams.isSuccess, // 操作结果: "成功"/"失败"
                status: 1, // 0 上传中，1上传成功
            }
            loading.value = true
            const [, res] = await awaitWrapper(queryOptLog(params))
            loading.value = false
            if (res && res.code == 0) {
                tableData.value = (res.data || []).map(item => {
                    return {
                        isEdit: false,
                        ...item,
                        createPerson: item.createName + '(' + item.createNo + ')',
                    }
                })
                pageDto.count = res.pageDto.count || 0
            }
        }

        const { pageDto, refresh, changePage, changeSize } = usePageDto(fetchList)
        // 使用表格高度 hook
        const tableRef = ref(null)
        const height = ref(180) // 页面其他部分的高度（搜索表单、按钮等）
        const { tableHeight, calcHeight } = useSetTableHeight({
            height: height.value, // 或者直接传数字
            pageDto: pageDto,
            tableRef: tableRef
        })
        const yearList = ref([])

        onMounted(async () => {
            fetchList()
        })


        const resetAll = () => {
            queryParams.createId = null
            queryParams.type = ''
            queryParams.isSuccess = ''
            refresh()
        }
        return {
            // 查询相关
            tableColumns,
            loading,
            queryParams,
            pageDto,
            tableData,
            refresh,
            changePage,
            changeSize,
            resetAll,
            // 查询条件
            yearList,

            tableRef,
            tableHeight,
            calcHeight,
        }
    },
})
</script>
<style lang="scss" scoped>
.main-container-content {
    padding: 20px;
    background-color: #fff;
}

.business-expense-name {
    background: #fff;
    -webkit-box-shadow: 0 2px 4px 0 #dbdee7;
    box-shadow: 0 2px 4px 0 #dbdee7;
    border-radius: 4px;
    margin: 16px;
    /* padding: 16px; */
}

.inline-block {
    display: inline-block;
}

.ml-10 {
    margin-left: 10px;
}

.mb-12 {
    margin-bottom: 12px;
}

.search-form {
    width: 100%;
}

.search-btn {
    text-align: right;
}

.left-btn {
    margin-bottom: 12px;
}

.el-row {
    display: flex;
    flex-wrap: wrap;
}


.amount-edit-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    height: 100%;

    .amount-input {
        flex: 1;
        max-width: 150px;
    }

    .amount-text {
        flex: 1;
        min-width: 80px;
        display: inline-block;
    }

    .edit-icon {
        font-size: 16px;
        color: #409EFF;
        cursor: pointer;
        transition: all 0.3s;
        padding: 4px;
        border-radius: 4px;

        &:hover {
            color: #66b1ff;
            background-color: #ecf5ff;
            transform: scale(1.1);
        }

        &:active {
            transform: scale(0.95);
        }

        /* &.el-icon-check {
            &:hover {
                color: #85ce61;
                background-color: #f0f9ff;
            }
        } */
    }
}
</style>
<style lang="scss" scoped>
/* 横向：固定列底部留空间 */
/deep/.el-table__fixed-body-wrapper .el-table__body {
    padding-bottom: 8px !important;
}

/* 横向错位：强制表头显示滚动条占位 */
/deep/.el-table__header-wrapper {
    overflow-y: scroll !important;
}
// /* 纵向：固定列向右偏移 */
// /deep/.el-table__fixed {
//     right: -8px !important;
// }
// /* 纵向：调整固定列宽度 */
// /deep/.el-table__fixed .el-table__fixed-header-wrapper,
// /deep/.el-table__fixed .el-table__fixed-body-wrapper {
//     width: calc(100% + 6px) !important;
// }
// /deep/.el-table__wrapper {
//     overflow: overlay;
// }

</style>